import { ConditionsManager } from '@/shared/components/conditions/models/conditionsManager';
import { ConditionPickerOption } from '@/shared/components/conditions/models/conditions';
import { store } from '@/store';
import { ConditionViewModel } from '@/shared/components/conditions/models/conditionViewModel';
import { InputVariableViewModel } from '@/features/bots/models/designer';

export enum DecisionConditionsAttributeType {
	TimeOfDay = 'system.currentTimeUtc',
}

export class DecisionConditionsManager extends ConditionsManager {
	private contextualConditions: ConditionPickerOption[] = [];

	constructor() {
		super(store.getters.contactAttributes);
	}

	public get conditions(): ConditionPickerOption[] {
		const attributes = this.conditionsFromCache;

		if (this.contextualConditions) {
			attributes.push(...this.contextualConditions);
		}
		return attributes;
	}

	public setContextualConditions(contextualConditions: ConditionPickerOption[]) {
		this.contextualConditions = contextualConditions;
	}

	public isConditionValid(condition: ConditionViewModel): boolean {
		if (condition.attribute.startsWith('flow')) {
			const flowVariables = store.getters.flowVariables;
			const flowVariable = flowVariables.find((fv: InputVariableViewModel) => fv.name === condition.attribute.split('.')[1]);
			return !!flowVariable;
		}
		return super.isConditionValid(condition);
	}

	public getConfigComponent(condition: ConditionViewModel) {
		if (condition.attribute === DecisionConditionsAttributeType.TimeOfDay) {
			return 'TimeOfDayCondition';
		}
		return super.getConfigComponent(condition);
	}

	public getFormattedDescription(condition: ConditionViewModel) {
		if (!condition.invalid && condition.attribute === DecisionConditionsAttributeType.TimeOfDay) {
			if (!condition.value || condition.value === 'bot.openingTimes') {
				return `Time of day is ${condition.result ? 'in hours' : 'out of hours'}`;
			} else {
				return 'Time of day is in custom schedule';
			}
		}
		return super.getFormattedDescription(condition);
	}
}
